import { Source, Layer } from "react-map-gl/mapbox"
import { feature } from "@turf/turf"
import type { Geometry } from "geojson"
import type { ICommune } from "@/types/explore"

interface CommuneContourLayerProps {
  commune?: ICommune
}

export const CommuneContourLayer = ({ commune }: CommuneContourLayerProps) => {
  const contourLayer = {
    id: "commune-contour",
    type: "line" as const,
    paint: {
      "line-color": "#1E40AF",
      "line-width": 3,
    },
  }

  if (!commune || !commune.contour) return null

  return (
    <Source id="commune-contour-layer" type="geojson" data={feature(commune.contour as Geometry)}>
      <Layer {...contourLayer} />
    </Source>
  )
}
